import {Session} from 'nutshell-core/session';

import {colors} from 'shells/colors/colors';
import {TargetRegularIcon} from 'shells/icon';
import {LoadingText} from 'shells/loading-placeholder/loading-text';
import {Body} from 'shells/typography/body';

import type {GetYearOverviewStats_quotaYearOverview as QuotaYearOverview} from 'nutshell-graphql-types';

import {
    formatCurrencyDisplay,
    getCalendarYear,
    getFiscalYearStartMonth,
    getMonthLabel,
} from './helpers';

import styles from './year-summary-table.module.css';

type Props = {
    quotaYearOverview: QuotaYearOverview;
    showEmptyState: boolean;
    isRefetching: boolean;
};

export function YearSummaryTable(props: Props) {
    const {quotaYearOverview, showEmptyState, isRefetching} = props;

    const fiscalYearStartMonth = getFiscalYearStartMonth();
    const currencyCode = Session.getInstanceDefaultCurrencyCode();

    return (
        <div className={styles['summary-card']}>
            <div className={styles['summary-header']}>
                <Body color='dark'>{quotaYearOverview.fiscalYear + ' totals'}</Body>
                <Body color='dark'>
                    {isRefetching ? (
                        <LoadingText width={90} />
                    ) : (
                        formatCurrencyDisplay(quotaYearOverview.yearValue.amount, currencyCode)
                    )}
                </Body>
            </div>
            <>
                {showEmptyState ? (
                    <div className='flex flex-dir-col align-center gap-8 py-16 px-8'>
                        {/* @ts-expect-error */}
                        <TargetRegularIcon size={30} color={colors.greyXlt} />
                        <Body color='light'>No quotas made yet</Body>
                    </div>
                ) : (
                    quotaYearOverview.months.map((month) => {
                        const calendarYear = getCalendarYear(
                            month.identifier,
                            quotaYearOverview.fiscalYear,
                            fiscalYearStartMonth
                        );

                        return (
                            <div
                                key={`${month.identifier}-${month.value.amount}`}
                                className={styles['month-row']}
                            >
                                <Body color='dark'>
                                    {getMonthLabel(
                                        month.identifier,
                                        calendarYear,
                                        fiscalYearStartMonth
                                    )}
                                </Body>
                                {isRefetching ? (
                                    <LoadingText width={60} />
                                ) : (
                                    <Body color='dark'>
                                        {formatCurrencyDisplay(month.value.amount, currencyCode)}
                                    </Body>
                                )}
                            </div>
                        );
                    })
                )}
            </>
        </div>
    );
}
